import React from 'react';
import { useParams } from 'react-router-dom';
import { TaskDetailPage } from './TaskDetailPage';

export const TaskDetailPageWrapper: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();

  return <TaskDetailPage key={taskId} />;
};
